<template>
    <div>
        <router-link :to="{
                        name: 'themes-slug',
                        params: {
                            slug: $t('labels.sea_theme_button').toLowerCase(),
                            theme: 'MilService_tab/Sea/'}}">
                    {{ $t('labels.sea_theme_button') }}
        </router-link>

        <router-link :to="{
                        name: 'themes-slug',
                        params: {
                            slug:  $t('labels.land_theme_button').toLowerCase(),
                            theme: 'MilService_tab/Land/'}}">
                    {{ $t('labels.land_theme_button') }}</router-link>

        <router-link :to="{
                        name: 'themes-slug',
                        params: {
                            slug:  $t('labels.air_theme_button').toLowerCase(),
                            theme: 'MilService_tab/air/'}}">
                    {{ $t('labels.air_theme_button') }}</router-link>

        <router-link :to="{
                         name: 'themes-slug',
                         params: {
                             slug:  $t('labels.women_theme_button').toLowerCase(),
                             theme: 'NamSex/Female/'}}">
                    {{ $t('labels.women_theme_button') }}</router-link>

    </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
    name: "Themes",
    methods: {
        slug(theme){
            var translatedLabel =  this.$translate('labels.age');
            return translatedLabel;
        }
    }

}
</script>